import {
  oDGoodsWeight,
  oDGoodsWeightTotal,
  odExport,
  odExportInfo,
} from '@/services/oDgoodsWeightInfo';

import BigNumber from 'bignumber.js';
import Filter from '../Filter';
import { computeWeights } from '@/utils/query';
import { crudRequest } from '@/services/api';
import { getData } from '@/components/report/service';
import moment from 'moment';
import { processObject } from '@/utils/formatUtil';
import { message } from 'antd';

// import { message } from 'antd';

/* eslint-disable no-console */

const paramsForm = {
  startDate: moment().add(-1, 'days').format('YYYY-MM-DD 00:00:00'),
  endDate: moment().format('YYYY-MM-DD 23:59:59'),
  // 总部没有默认值
  centerFilter: '',
  provinceArea: '',
  centerFilterDepart: '',
  provinceAreaDepart: '',
};

export default {
  namespace: 'odgoodsweightinfo',
  state: {
    oDGoodsWeight: [], // 按照公斤段展示的table列表
    oDGoodsWeightTotal: {}, // 按照公斤段展示的table列表 合计数据
    active: 'departure',
    tableColumnsType: 'product', // 表格展示类型
    tableColumns: [
      {
        value: 'product',
        label: '按产品类型展示',
      },
      {
        value: 'kilogram',
        label: '按公斤段展示',
      },
    ], // 表格列类型
    searchParams: { ...paramsForm },
    dataList: [],
    totalRow: {},
    activeChange: {
      active: 'arrive',
      searchParams: { ...paramsForm },
      dataList: [],
      totalRow: {},
    },
  },

  effects: {
    *getDatas(_, { put, select, call }) {
      const {
        tableColumnsType,
        searchParams: {
          centerFilter,
          provinceArea,
          startDate,
          endDate,
          centerFilterDepart,
          provinceAreaDepart,
        },
      } = yield select(({ odgoodsweightinfo }) => odgoodsweightinfo);

      const ODGoodsWeightQueryVo = {
        startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'), // 时间区间-开始
        endDate: moment(endDate).format('YYYY-MM-DD 23:59:59'), // 时间区间-结束
        originCenter: centerFilter?.name, // 始发分拨
        originCenterCode: centerFilter?.code, // 始发分拨编码
        destinationCenter: centerFilterDepart?.name, // 目的分拨
        destinationCenterCode: centerFilterDepart?.code, // 目的分拨编码
        originProvinceArea: provinceArea?.name, // 始发营运区
        originProvinceAreaCode: provinceArea?.code, // 始发营运区编码
        destinationProvinceArea: provinceAreaDepart?.name, // 目的营运区
        destinationProvinceAreaCode: provinceAreaDepart?.code, // 目的营运区编码
      };
      try {
        const { data: ODGoodsWeightData = [] } = yield call(oDGoodsWeight, ODGoodsWeightQueryVo);
        const { data: ODGoodsWeightTotalData = {} } = yield call(
          oDGoodsWeightTotal,
          ODGoodsWeightQueryVo,
        );
        const _oDGoodsWeight = processObject(ODGoodsWeightData);
        console.log(
          '%c [ _oDGoodsWeight ]-85',
          'font-size:13px; background:pink; color:#bf2c9f;',
          _oDGoodsWeight[0],
        );
        const _ODGoodsWeightTotalData = processObject(ODGoodsWeightTotalData);
        console.log(
          '%c [ _ODGoodsWeightTotalData ]-87',
          'font-size:13px; background:pink; color:#bf2c9f;',
          _ODGoodsWeightTotalData,
        );

        yield put({
          type: 'updateState',
          payload: {
            oDGoodsWeight: _oDGoodsWeight,
            oDGoodsWeightTotal: _ODGoodsWeightTotalData,
          },
        });
      } catch (error) {
        // 错误处理
        console.error(
          'Error occurred while processing ODGoodsWeightData or ODGoodsWeightTotalData:',
          error,
        );
        yield put({
          type: 'updateState',
          payload: {
            oDGoodsWeight: {},
            oDGoodsWeightTotal: {},
          },
        });
      }
    },
    *getData(_, { put, select }) {
      crudRequest('/api/route/odGoodsWeightInfo/search'); // 日志
      const {
        searchParams: {
          centerFilter,
          provinceArea,
          startDate,
          endDate,
          centerFilterDepart,
          provinceAreaDepart,
        },
      } = yield select(({ odgoodsweightinfo }) => odgoodsweightinfo);
      // if (!centerFilter && !provinceArea && !centerFilterDepart && !provinceAreaDepart) {
      // return message.error("至少选择一个查询条件！")
      // }
      const filter = Filter({
        originCenter: centerFilter?.name,
        originProvinceArea: provinceArea?.name,
        destinationCenter: centerFilterDepart?.name,
        destinationProvinceArea: provinceAreaDepart?.name,
        startDate,
        endDate,
      });

      const reqAll = filter.map((filterItem) => getData(filterItem));
      const dataSource = yield Promise.all(reqAll);
      let dataList = [];
      if (dataSource.length > 0) {
        dataSource[0].forEach((item, i) => {
          if (item.destinationCenter) {
            const originCenter = item.originCenter;
            const destinationCenter = item.destinationCenter;
            const originProvinceArea = item.originProvinceArea;
            const destinationProvinceArea = item.destinationProvinceArea;
            item.originCenter2 = originCenter?.replace(/分拨中心|经营本部|省区|营运区|管理区/g, '');
            item.destinationCenter2 = destinationCenter?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.originProvinceArea2 = originProvinceArea?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.originProvinceArea2 = item.originProvinceArea2?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.destinationProvinceArea2 = destinationProvinceArea?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.destinationProvinceArea2 = item.destinationProvinceArea2?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.routePath2 = item.originCenter2 + '-' + item.destinationCenter2;
            const obj = { index: i, ...item, weight0: item.calcWeight };
            dataList.push(obj);
          }
        });

        for (let i = 1; i < dataSource.length; i++) {
          const dsItem = dataSource[i];
          for (let j = 0; j < dataList.length; j++) {
            const firstItem = dataList[j];
            dataList[j][`weight${i}`] = 0;
            dsItem.find((lastItem) => {
              if (
                firstItem.originCenter === lastItem.originCenter &&
                firstItem.destinationCenter === lastItem.destinationCenter
                // && firstItem.originProvinceArea === lastItem.originProvinceArea
              ) {
                dataList[j] = { ...firstItem, [`weight${i}`]: lastItem.calcWeight };
                return true;
              }
              return false;
            });
          }
        }
      }
      const totalRow = { totalRow: '合计', length: dataSource.length - 1 };
      dataList.forEach((item) => {
        for (let i = 0; i < dataSource.length; i++) {
          if (!totalRow[`weight${i}`]) {
            totalRow[`weight${i}`] = 0;
          }
          totalRow[`weight${i}`] = Number.parseFloat(
            new BigNumber(totalRow[`weight${i}`]).plus(item[`weight${i}`]).toString(),
          );
          item[`weight${i}`] = computeWeights(item[`weight${i}`], 2);
        }
      });
      yield put({ type: 'updateState', payload: { dataList, totalRow } });
    },
    // 导出
    *exportData({ payload, callback }, { call }) {
      try {
        // exportType 为 'info' 时走导出明细接口，入参与导出列表一致
        const { exportType, ...rest } = payload || {};
        const params = {
          ...rest,
          startDate: moment(rest.startDate).format('YYYY-MM-DD 00:00:00'),
          endDate: moment(rest.endDate).format('YYYY-MM-DD 23:59:59'),
        };
        const response = yield call(exportType === 'info' ? odExportInfo : odExport, params);
        if (response && response.code === 1) {
          // 导出成功
          message.success('导出成功');
          callback && callback();
        } else {
          // 导出失败
          message.error(`${response?.message} || 导出失败`);
        }
      } catch (error) {
        // 捕获异常
        message.error(`${error?.message} || 导出失败`);
        console.error('导出过程中发生错误:', error);
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    // eslint-disable-next-line no-unused-vars
    updateActive(state, { payload }) {
      const { activeChange, tableColumnsType, tableColumns, ...states } = state;
      return {
        ...activeChange,
        activeChange: {
          ...states,
          searchParams: { ...states.searchParams },
        },
        tableColumns,
        tableColumnsType,
      };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
